import React from "react";
import { useTranslation } from "react-i18next";

import { FlagIcon, WarningIcon } from "fe-shared/src/components/Icons";

import { FLAG_COLOR } from "../../../../consts";
import { PickupRequestListItem } from "../../../../types";

import styles from "./RequestWarningsGridCell.module.scss";

interface Props {
  data: PickupRequestListItem;
  /** The carrier concerns the hauler alone; a collector has no carrier column to warn about. */
  showCarrierWarning?: boolean;
}

// The flag reaches a participant only when the portal set ShowFlagToParticipants - the procedure
// returns 0 otherwise - so this renders whatever the server chose to share, and decides nothing.
const RequestWarningsGridCell = ({ data, showCarrierWarning }: Props) => {
  const { t } = useTranslation();
  const hasCarrierWarning = !!showCarrierWarning && !data.carrierFirstName;

  if (!hasCarrierWarning && !data.isFlagged) {
    return null;
  }

  return (
    <span className={styles.warnings}>
      {hasCarrierWarning && (
        <span title={t("pickupRequests.grid.warnings.carrierNotAssigned")}>
          <WarningIcon />
        </span>
      )}
      {data.isFlagged && (
        <span title={t("pickupRequests.grid.warnings.flagged")}>
          <FlagIcon fillColor={FLAG_COLOR} />
        </span>
      )}
    </span>
  );
};

export default RequestWarningsGridCell;
